import { IComment } from 'app/components/CommonStyled/Comment';

import { http } from './http';

export type MessageableType =
  | 'resource'
  | 'message'
  | 'person'
  | 'company'
  | 'project'
  | 'passion'
  | 'skill'
  | 'industry'
  | 'client';

interface ICommentParams {
  content: string;
  messageable_type: MessageableType;
  messageable_uuid_or_slug: string;
  parent_uuid?: string;
}

export const postComment = (data: ICommentParams) => {
  return http.post<IComment>('/messages', data);
};

export const deleteComment = (uuid: string) => {
  return http.delete(`/messages`, { message_uuid: uuid });
};

export const editComment = (data: { content: string; message_uuid: string }) => {
  return http.put(`/messages`, data);
};
